import React from 'react';

import { FluxStudyStatusCode, getFluxStudyStatusMeta } from 'constants/fluxStudyStatus';

import './index.scss';

// Tom de cor por código: cada valor é uma chave do mapa `$my-studies-status-colors` (_grid.scss).
const STATUS_TONES: Readonly<Record<FluxStudyStatusCode, string>> = {
  em_fila: 'em-fila',
  executando: 'executando',
  pronto: 'estudo-pronto',
  erro: 'com-erro',
  cancelado: 'cancelado',
};

export interface StudyStatusPillProps {
  /** Código do status; `null` quando o backend mandou um código desconhecido. */
  status: FluxStudyStatusCode | null;
  /** Rótulo do backend (`status_rotulo`), usado só no fallback de código desconhecido. */
  fallbackLabel?: string;
}

/**
 * Selo de status da nova aba Meus Estudos: pílula clara com bolinha, nas cores do Claude Design
 * (D25, .dc.html:567). Código desconhecido cai num tom neutro, com o rótulo do backend.
 * Não substitui o `StatusTag` do Flux Upload e do get-list legado.
 */
export default function StudyStatusPill({ status, fallbackLabel }: StudyStatusPillProps) {
  // Rótulo e tom saem da mesma decisão: um código fora do contrato cai no neutro por inteiro.
  const { code, label } = getFluxStudyStatusMeta(status, fallbackLabel);
  const tone = code === null ? 'unknown' : STATUS_TONES[code];

  return (
    <span className={`my-studies-status-pill my-studies-status-pill--${tone}`}>
      <span className="my-studies-status-pill-dot" aria-hidden="true" />
      {label}
    </span>
  );
}
